
import React, {useEffect, useState } from 'react';
import '../Assets/Css/intro.css';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function IntroStrategySessions() {

    useEffect(() => {
        AOS.init({ duration: 1000, once: false });
        AOS.refresh();
      }, []);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleDateChange = (date) => {
    setSelectedDate(date);
    console.log("Selected Date:", date);
  };

const testimonials = [
    "Mobius Unity helped us scale our regenerative agriculture practices by offering strategic insights and data-driven planning. Their team truly understands how to blend nature-based solutions with innovation.",
    "The technical and operational support from Mobius Unity was crucial to our success in deploying water-saving technologies in remote communities. Their collaborative approach made all the difference.",
    "Their strategic planning and risk assessment services gave us a clear roadmap to scale our solar microgrid systems. They don't just consult — they become part of your journey.",
    "Mobius Unity’s work on sustainable community models and business-government engagement has set a new benchmark in how private organizations support public initiatives.",
    "From market strategy to operations, their team brought structure and momentum to our vision. Mobius Unity's values align perfectly with impact-driven entrepreneurs like us.",
  ];

  return (
    <div style={{ minHeight: '100vh' }}>
     <Helmet>
      {/* Page Title */}
      <title>Free Strategy Session | Mobius Unity Consulting</title>

      {/* Meta Description */}
      <meta
        name="description"
        content="Book your free 30-minute intro & strategy session with Mobius Unity Consulting. Discover how we can support your goals with sustainable growth solutions and expert guidance."
      />

      {/* Keywords */}
      <meta
        name="keywords"
        content="Mobius Unity strategy session, free consultation, sustainability planning, regenerative consulting, growth strategy, Austin Niles, sustainable business consulting"
      />

      {/* Author */}
      <meta name="author" content="Mobius Unity Consulting" />

      {/* Canonical URL */}
      <link rel="canonical" href="https://mobiusunityconsulting.com/strategy-session" />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content="Free Strategy Session | Mobius Unity Consulting" />
      <meta
        property="og:description"
        content="Schedule your free consultation and explore how Mobius Unity Consulting can help you grow with impact-driven strategies and regenerative solutions."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://mobiusunityconsulting.com/strategy-session" />
      <meta property="og:image" content="https://mobiusunityconsulting.com/assets/session-og-image.jpg" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Free 30-Minute Strategy Session" />
      <meta
        name="twitter:description"
        content="Book a free strategy session with Mobius Unity Consulting and turn your sustainability goals into action. Let’s grow together."
      />
      <meta name="twitter:image" content="https://mobiusunityconsulting.com/assets/session-twitter-image.jpg" />
      <meta name="twitter:site" content="@MobiusUnity" />
    </Helmet>

      {/* Banner */}
      <div className="bannereintro-section d-flex align-items-center justify-content-center">
        <div className="bannereintro-overlay text-center" data-aos="zoom-in">
          <h2 className="banner1-title">Intro and Strategy Sessions</h2>
          <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">
            Free 30-Minute Intro & Strategy Session
          </p>
        </div>
      </div>

      {/* Booking Section */}
      <section className="booking-section py-5" style={{backgroundColor:'#F8FBFF'}} data-aos="zoom-in">
        <div className="container">
          <Row className="justify-content-center">
            <Col md={9} lg={9}>
              <div className="p-4 shadow-sm border rounded bg-white">
                <Row className="justify-content-center">
                   <Col md={6} lg={6}>
                <h3 className="mb-3 fw-bold text-center">Austin Niles</h3>
                <p><strong>Session:</strong> Intro & Strategy Session</p>
                <p><strong>Duration:</strong> 30 minutes</p>
                <p><strong>Mode:</strong> Phone call</p>
                <p className="text-muted">
                  This free session will help identify how Mobius Unity Consulting can provide ongoing support for your operation’s growth.
                </p>
                </Col>
</Row>
                <hr />

                <h5 className="mt-4 text-center">Select a Date & Time</h5>
                <div className="calendar-placeholder border rounded p-3 my-3 d-flex justify-content-center">
  <Calendar
    onChange={handleDateChange}
    value={selectedDate}
    minDate={new Date()}
  />
</div>


                <p className="text-muted small">Time zone: India Standard Time (IST)</p>
                
              
              </div>
            </Col>
          </Row>
        </div>
      </section>

<section className="ctaintro-section text-center ">
        <div className="container">
          <h3 className="text-dark fw-bold text-center section-title" data-aos="fade-down" data-aos-delay="100">
                    Ready to elevate your strategy?
                      <span className="title-decoration mb-2"></span>
                    </h3>
         
          <p className="text-dark mb-4" data-aos="zoom-in" data-aos-delay="100">
            Schedule your free consultation and let’s transform your vision into action.
          </p>
         <Button variant="light" className="banner2-button " href='/contact'
                                data-aos="zoom-in" data-aos-delay="300" >
                              Book Now <IoArrowForwardCircleOutline size={30} style={{ animation: 'pulse 1.5s infinite', transformOrigin: 'center' }} />
                              </Button>
        </div>
      </section>
    
  <section className="testimonial-carousel-section my-5">
                <div className="container py-3 ">
                  <Row className="align-items-center justify-content-center flex-md-row m-0">
                    <h3 className="fw-bold text-center section-title" data-aos="fade-down" data-aos-delay="100">
                      Empowering <span style={{ color: '#04A1D3' }}>Innovation</span>
                      <span className="title-decoration mb-2"></span>
                    </h3>
                    <p className="text-muted text-center" style={{ maxWidth: 700 }} data-aos="fade-down" data-aos-delay="100">
                      we deliver smart solutions that empower growth and innovation.
                    </p>
                    <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">
      
                      <Swiper
                        modules={[Autoplay, Pagination, Navigation]}
                        spaceBetween={30}
                        loop={true}
                        autoplay={{
                          delay: 5000,
                          disableOnInteraction: false,
                        }}
                        pagination={{ clickable: true }}
                        navigation={true}
                        className="testimonial-swiper"
                      >
                        {testimonials.map((text, idx) => (
                          <SwiperSlide key={idx}>
                            <div className="stars mb-1">
                              {[...Array(5)].map((_, i) => (
                                <FaStar key={i} color="#036839" />
                              ))}
                            </div>
                            <p className="testimonial-quote">
                              <span className="quote-mark">“</span>
                              {text}
                              <span className="quote-mark">”</span>
                            </p>
                            <p className="author-name">Anonymous</p>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </Col>
                  </Row>
                </div>
              </section>
    </div>
  );
}
